import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  Select,
  Slider,
  Stack,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { createMatch } from "../../api/matches";
import Mapper from "../../components/generalMapper";
import { TOAST_SETTINGS } from "../../config/constants";
import useToastContext from "../../config/useToastContext";
import { useFormData } from "../../context/FormContext";

const Div = styled("div", {
  name: "MuiDiv",
  overridesResolver: (props, styles) => {
    return [styles.root];
  },
})();

export default function ReefscapeForm({ user, signOut }) {
  //Form Data
  const { formData, updateFormData } = useFormData();
  const context = useOutletContext();
  const { updateRobotNumber } = context;

  //Start Match Timer
  const [visualTime, setVisualTime] = useState(0);

  const startMatch = async (e) => {
    let timerId = setInterval(countdown, 1000);
    let newVisualTime = 1;
    setVisualTime(newVisualTime);
    function countdown() {
      if (newVisualTime <= 15) {
        newVisualTime = newVisualTime + 1;
      } else if (newVisualTime > 15) {
        newVisualTime = 16;
        clearTimeout(timerId);
      }
      setVisualTime(newVisualTime);
    }
    setCurrentLocation("start");
  };

  //AutoMapping
  const [currentLocation, setCurrentLocation] = useState("robotPosition");
  const autoImageBox = useRef(null);
  const [autoImageSize, setAutoImageSize] = useState(0);

  useEffect(() => {
    const updateSize = () => {
      if (autoImageBox.current) {
        setAutoImageSize(autoImageBox.current.offsetWidth * 0.95);
      }
    };

    updateSize();

    window.addEventListener("resize", updateSize);

    return () => {
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  const addToast = useToastContext();

  const REEFSCAPEMAP = [
    {
      id: 0,
      title: "reef1",
      shape: "poly",
      name: "reef1",
      fillColor: "#bada5555",
      coords: [547, 490, 494, 398, 551, 300, 660, 490],
    },
    {
      id: 1,
      title: "reef2",
      shape: "poly",
      name: "reef2",
      fillColor: "#bada5555",
      coords: [547, 491, 494, 583, 556, 680, 660, 491],
    },
    {
      id: 2,
      title: "reef3",
      shape: "poly",
      name: "reef3",
      fillColor: "#bada5555",
      coords: [386, 583, 494, 583, 556, 680, 330, 680],
    },
    {
      id: 3,
      title: "reef4",
      shape: "poly",
      name: "reef4",
      fillColor: "#bada5555",
      coords: [333, 491, 386, 583, 330, 680, 220, 491],
    },
    {
      id: 4,
      title: "reef5",
      shape: "poly",
      name: "reef5",
      fillColor: "#bada5555",
      coords: [333, 490, 386, 398, 330, 300, 220, 490],
    },
    {
      id: 5,
      title: "reef6",
      shape: "poly",
      name: "reef6",
      fillColor: "#bada5555",
      coords: [386, 398, 494, 398, 551, 300, 330, 300],
    },
    {
      id: 6,
      title: "pickup1",
      shape: "circle",
      name: "pickup1",
      fillColor: "#bada5555",
      coords: [240, 133.5, 50],
    },
    {
      id: 7,
      title: "pickup2",
      shape: "circle",
      name: "pickup2",
      fillColor: "#bada5555",
      coords: [440.5, 133.5, 50],
    },
    {
      id: 8,
      title: "pickup3",
      shape: "circle",
      name: "pickup3",
      fillColor: "#bada5555",
      coords: [641, 133.5, 50],
    },
    {
      id: 9,
      title: "algae",
      shape: "poly",
      name: "algae",
      fillColor: "#bada5555",
      coords: [6, 566, 92, 566, 92, 764, 875, 764, 875, 880, 6, 880],
    },
    {
      id: 10,
      title: "coral_station1",
      shape: "poly",
      name: "coral_station1",
      fillColor: "#bada5555",
      coords: [139, 5, 5, 189, 78, 242, 212, 58],
    },
    {
      id: 11,
      title: "coral_station2",
      shape: "poly",
      name: "coral_station2",
      fillColor: "#bada5555",
      coords: [741, 5, 875, 189, 802, 242, 668, 58],
    },
  ];
  const START = [
    {
      id: 0,
      title: "robotPosition",
      shape: "rect",
      name: "robotPosition",
      fillColor: "#bada5555",
      coords: [6, 767, 875, 880],
    },
  ];

  const handleZoneSelect = (zoneName) => {
    setCurrentLocation(zoneName);
  };

  const buttonChange = (math, propertyName) => {
    let value = formData[propertyName];
    if (value === undefined) {
      value = 0;
    }
    math === "add" ? (value = value + 1) : (value = value - 1);
    if (value <= 0) {
      value = 0;
    }
    updateFormData({
      ...formData,
      [propertyName]: Number(value),
    });
  };

  const handleStringChange = (e) => {
    updateFormData({
      ...formData,
      [e.target.name]: `${e.target.value}`,
    });
  };

  const handleSliderChange = (e) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckBoxChange = (e) => {
    let value = e.target.checked;

    updateFormData({
      ...formData,
      [e.target.name]: Boolean(value) ? 1 : 0,
    });
  };

  const autoRouteLocation = (action) => {
    let value = currentLocation + "_" + action;
    let arrayValue =
      formData?.auto_actions?.length > 0 ? [...formData?.auto_actions] : [];
    arrayValue.push(value);
    updateFormData({
      ...formData,
      auto_actions: arrayValue,
    });
    setCurrentLocation("between");
  };

  useEffect(() => {
    if (formData?.is_reseting) {
      console.log("reseting");
      updateRobotNumber();
    }
  }, [formData]);

  const handleResetForm = () => {
    setAutoExpanded(true);
    setVisualTime(0);
    updateFormData({
      ...formData,
      match_number: formData.match_number + 1,
      robot_number: 0,
      auto_actions: [],
      teleop_level4: 0,
      teleop_level3: 0,
      teleop_level2: 0,
      teleop_level1: 0,
      teleop_net_scored: 0,
      teleop_net_missed: 0,
      teleop_processor_scored: 0,
      teleop_missed_coral: 0,
      endgame_type: "no_attempt",
      robot_speed: 3,
      robot_agility: 3,
      robot_defense: 0,
      robot_climbing_speed: 0,
      robot_dislodge_algae: 0,
      robot_algae_controlled: 0,
      robot_coral_can_handle: 0,
      robot_travel_under_barge: 0,
      errors_mistakes_lost_comms: 0,
      errors_mistakes_stuck_piece: 0,
      errors_mistakes_extra_piece: 0,
      errors_official_yellow_card: 0,
      errors_official_red_card: 0,
      robot_tippy: 0,
      robot_tipped: 0,
      robot_damaged: 0,
      errors_gameplay_battlebot: 0,
      errors_official_foul: 0,
      errors_gameplay_nuisance: 0,
      errors_gameplay_touched_cage: 0,
      errors_gameplay_knocked_cage: 0,
      notes: "",
      starting_location: -1,
      is_reseting: true,
    });
    setSubmitEnabled(true);
  };

  const reqProps = [
    { prop: "event", emptyValue: "", commonName: "Event" },
    { prop: "robot_number", emptyValue: 0, commonName: "Robot Number" },
    { prop: "match_number", emptyValue: 0, commonName: "Match Number" },
  ];

  const handleCreateMatch = async () => {
    console.log(formData);
    setSubmitEnabled(false);

    // check to see if all the properties to submit are correct
    let missingProps = [];
    reqProps.forEach((reqProp) => {
      if (formData[reqProp?.prop] === reqProp.emptyValue) {
        missingProps.push(reqProp.commonName);
      }
    });

    if (missingProps.length === 0) {
      console.log(formData);
      const response = await createMatch(formData);
      if (response.statusCode === 200) {
        addToast({
          message: "Successfully Recorded the Match",
          severity: TOAST_SETTINGS.severity.SUCCESS,
        });
      } else {
        addToast({
          message: "There was an error saving the match.",
          severity: TOAST_SETTINGS.severity.ERROR,
        });
      }
      handleResetForm();
    } else {
      addToast({
        message: `You are missing the following required properties ${missingProps
          .map((prop) => prop)
          .join(", ")}`,
        severity: TOAST_SETTINGS.severity.ERROR,
      });
      setSubmitEnabled(true);
    }
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setAutoExpanded(isExpanded ? panel : false);
  };

  const [autoExpanded, setAutoExpanded] = useState(true);

  const [submitEnabled, setSubmitEnabled] = useState(true);

  const handleIncrementingChange = (currentState) => {
    setIncrementing(currentState ? false : true);
    console.log(incrementing);
  };

  const [incrementing, setIncrementing] = useState(true);
  return (
    <Div
      id="foreground"
      variant="filled"
      sx={{
        borderRadius: 2,
        backgroundColor: "foreground.dark",
        mt: 2,
        overflow: "hidden",
      }}
    >
      {/*Auto*/}
      <Accordion
        expanded={autoExpanded}
        onChange={handleAccordionChange("auto")}
        sx={{
          backgroundColor: "background.main",
          borderRadius: 2,
        }}
      >
        <AccordionSummary
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            "& .MuiAccordionSummary-content": {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 1,
              position: "relative",
            },
          }}
          expandIcon={<ArrowDropDownIcon sx={{ color: "#fff" }} />}
        >
          <Box
            sx={{
              width: "36px",
              visibility: "hidden",
            }}
          />

          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              padding: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "60%",
              bgcolor: "background.default",
            }}
          >
            <Typography variant="h5" color="secondary.light">
              <b>A U T O</b>
            </Typography>
          </Paper>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Grid
              container
              sx={{ my: 1, display: "flex", alignItems: "center" }}
            >
              {/*Map*/}
              <Grid item xs={12} md={6}>
                <Box sx={{ display: { xs: "none", md: "contents" } }}>
                  {visualTime > 0 && visualTime < 16 && (
                    <Box
                      sx={{
                        backgroundColor: "secondary.main",
                        borderRadius: 1,
                        padding: 1,
                        justifyItems: "center",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <b>{visualTime}</b>
                      </Typography>
                    </Box>
                  )}
                  {(visualTime === 0 || visualTime === 16) && (
                    <Button
                      variant="contained"
                      onClick={() =>
                        formData.starting_location !== -1 && visualTime === 0
                          ? startMatch()
                          : visualTime === 16
                          ? setAutoExpanded(false)
                          : ""
                      }
                      sx={{ width: "100%", height: 60 }}
                    >
                      {visualTime === 0 ? "Start" : "Finish"}
                    </Button>
                  )}
                </Box>
                <Box
                  ref={autoImageBox}
                  sx={{
                    backgroundColor: "gray.main",
                    borderRadius: 2,
                    padding: 3,
                    justifyItems: "center",
                    width: "100%",
                  }}
                >
                  <Mapper
                    parentWidth={autoImageSize}
                    image="reefscape"
                    map={visualTime === 0 ? START : REEFSCAPEMAP}
                    onSelectArea={handleZoneSelect}
                    updateRobotPosition={(e) =>
                      updateFormData({
                        starting_location: Number(e),
                      })
                    }
                  />
                </Box>
              </Grid>
              <Box sx={{ display: { xs: "contents", md: "none" } }}>
                <Grid item xs={12} sx={{ m: 2 }}>
                  {visualTime > 0 && visualTime < 16 && (
                    <Box
                      sx={{
                        backgroundColor: "secondary.main",
                        borderRadius: 1,
                        padding: 1,
                        justifyItems: "center",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <b>{visualTime}</b>
                      </Typography>
                    </Box>
                  )}
                  {(visualTime === 0 || visualTime === 16) && (
                    <Button
                      variant="contained"
                      onClick={() =>
                        formData.starting_location !== -1 && visualTime === 0
                          ? startMatch()
                          : visualTime === 16
                          ? setAutoExpanded(false)
                          : ""
                      }
                      sx={{
                        width: "100%",
                        height: 60,
                      }}
                    >
                      {visualTime === 0 ? "Start" : "Finish"}
                    </Button>
                  )}
                </Grid>
              </Box>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  height: autoImageSize,
                  alignContent: "center",
                  justifyItems: "center",
                  px: 2,
                }}
              >
                {/*Before*/}
                {visualTime === 0 && (
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      padding: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "90%",
                      bgcolor: "background.default",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 11,
                      }}
                    >
                      <b>
                        Select A Starting Location and Click Start When Ready
                      </b>
                    </Typography>
                  </Paper>
                )}
                {/*Start*/}
                {currentLocation.includes("start") && (
                  <Button
                    variant="contained"
                    onClick={() => autoRouteLocation("left")}
                    sx={{ display: "flex", width: "100%", height: "100%" }}
                  >
                    Left Starting Zone (Click If Only Thing They Did)
                  </Button>
                )}
                {/*Between*/}
                {currentLocation.includes("between") && (
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      padding: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "90%",
                      bgcolor: "background.default",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 11,
                      }}
                    >
                      <b>Choose a new Location</b>
                    </Typography>
                  </Paper>
                )}
                {/*Reef Actions*/}
                {currentLocation.includes("reef") && (
                  <Stack
                    spacing={2}
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 20,
                      }}
                    >
                      <b>{currentLocation.toUpperCase()}</b>
                    </Typography>
                    <Stack
                      direction="row"
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Stack
                        spacing={2}
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          mx: 1,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("4L")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            High L
                          </Button>
                          <Typography sx={{ width: "20%" }}></Typography>
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("4R")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            High R
                          </Button>
                        </Stack>
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("3L")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            Mid L
                          </Button>
                          <Typography sx={{ width: "20%" }}></Typography>
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("3R")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            Mid R
                          </Button>
                        </Stack>
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("2L")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            Low L
                          </Button>
                          <Typography sx={{ width: "20%" }}></Typography>
                          <Button
                            variant="contained"
                            onClick={() => autoRouteLocation("2R")}
                            sx={{ width: "30%", height: "100%" }}
                          >
                            Low R
                          </Button>
                        </Stack>
                        <Button
                          color="black"
                          variant="contained"
                          onClick={() => autoRouteLocation("1")}
                          sx={{
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          Trough
                        </Button>
                        <Button
                          color="red"
                          variant="contained"
                          onClick={() => autoRouteLocation("missed")}
                          sx={{
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          Missed Coral
                        </Button>
                      </Stack>
                      <Stack
                        spacing={2}
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          ml: 1,
                          mr: 2,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={() => autoRouteLocation("algae_controlled")}
                          color="secondary"
                          sx={{
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          Picked Off Algae
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() =>
                            autoRouteLocation("algae_uncontrolled")
                          }
                          color="secondary"
                          sx={{
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          Hit Off Algae
                        </Button>
                      </Stack>
                    </Stack>
                  </Stack>
                )}
                {/*Pick Up Actions*/}
                {currentLocation.includes("pickup") && (
                  <Stack
                    spacing={2}
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 20,
                      }}
                    >
                      <b>{currentLocation.toUpperCase()}</b>
                    </Typography>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("algae")}
                        color="secondary"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Picked Up Algae
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("both")}
                        color="blue"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Picked Up Both
                      </Button>
                    </Stack>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("coral")}
                        color="primary"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Picked Up Coral
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("missed")}
                        color="red"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Missed
                      </Button>
                    </Stack>
                  </Stack>
                )}
                {/*Algae Actions*/}
                {currentLocation.includes("algae") && (
                  <Stack
                    spacing={2}
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 20,
                      }}
                    >
                      <b>{currentLocation.toUpperCase()}</b>
                    </Typography>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("net_scored")}
                        color="secondary"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Scored Net
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("net_missed")}
                        color="red"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Missed Net
                      </Button>
                    </Stack>
                    <Box
                      sx={{
                        borderRadius: 1,
                        backgroundColor: "primary.light",
                        width: "95%",
                        height: "3%",
                      }}
                    ></Box>
                    <Stack
                      spacing={2}
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("processor_scored")}
                        color="secondary"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Scored Processor
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => autoRouteLocation("processor_missed")}
                        color="red"
                        sx={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Missed Processor
                      </Button>
                    </Stack>
                  </Stack>
                )}
                {/*Coral Station Actions*/}
                {currentLocation.includes("coral_station") && (
                  <Stack
                    spacing={2}
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Typography
                      color="primary.light"
                      sx={{
                        textAlign: "center",
                        px: 2,
                        fontSize: autoImageSize / 20,
                      }}
                    >
                      <b>{currentLocation.toUpperCase()}</b>
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={() => autoRouteLocation("picked_up")}
                      color="primary"
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      Picked Up Coral
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => autoRouteLocation("missed")}
                      color="red"
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      Missed Coral
                    </Button>
                  </Stack>
                )}
              </Grid>
            </Grid>
          </Box>
        </AccordionDetails>
      </Accordion>
      {/*Teleop*/}
      {visualTime === 16 && (
        <Box>
          <Grid container sx={{ my: 1 }}>
            <Grid item xs={12} sx={{ justifyItems: "center" }}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 2,
                  padding: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "60%",
                  bgcolor: "background.default",
                  mb: 2,
                }}
              >
                <Typography
                  variant="h5"
                  color="secondary.light"
                  sx={{ textAlign: "center" }}
                >
                  <b>T E L E O P</b>
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={6}>
              <Stack
                spacing={2}
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  mx: 1,
                }}
              >
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_level4"
                    )
                  }
                  variant="contained"
                  color={incrementing ? "primary" : "red"}
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`High (${formData?.teleop_level4 ?? 0})`}
                </Button>
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_level3"
                    )
                  }
                  variant="contained"
                  color={incrementing ? "primary" : "red"}
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`Mid (${formData?.teleop_level3 ?? 0})`}
                </Button>
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_level2"
                    )
                  }
                  variant="contained"
                  color={incrementing ? "primary" : "red"}
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`Low (${formData?.teleop_level2 ?? 0})`}
                </Button>
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_level1"
                    )
                  }
                  variant="contained"
                  color={incrementing ? "black" : "red"}
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`Trough (${formData?.teleop_level1 ?? 0})`}
                </Button>
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_missed_coral"
                    )
                  }
                  color="red"
                  variant="contained"
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`Missed Coral (${formData?.teleop_missed_coral ?? 0})`}
                </Button>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack spacing={2} sx={{ alignItems: "center", px: 2 }}>
                <Button
                  onClick={() => handleIncrementingChange(incrementing)}
                  variant="contained"
                  color={incrementing ? "blue" : "red"}
                  sx={{ width: "100%", minHeight: 216 }}
                >
                  {incrementing ? "INC" : "DEC"}
                </Button>
                <Box
                  sx={{
                    borderRadius: 1,
                    minHeight: 32,
                  }}
                ></Box>
                <Box
                  sx={{
                    borderRadius: 0.5,
                    backgroundColor: "primary.light",
                    width: "75%",
                    minHeight: 4,
                  }}
                ></Box>
                <Box
                  sx={{
                    borderRadius: 1,
                    minHeight: 32,
                  }}
                ></Box>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ width: "100%", alignItems: "center" }}
                >
                  <Button
                    onClick={() =>
                      buttonChange(
                        incrementing ? "add" : "subtract",
                        "teleop_net_scored"
                      )
                    }
                    variant="contained"
                    color={incrementing ? "secondary" : "red"}
                    sx={{ width: "100%", minHeight: 100 }}
                  >
                    {`Scored Algae In Net (${
                      formData?.teleop_net_scored ?? 0
                    })`}
                  </Button>
                  <Button
                    onClick={() =>
                      buttonChange(
                        incrementing ? "add" : "subtract",
                        "teleop_net_missed"
                      )
                    }
                    variant="contained"
                    color="red"
                    sx={{ width: "100%", minHeight: 100 }}
                  >
                    {`Missed Net (${formData?.teleop_net_missed ?? 0})`}
                  </Button>
                </Stack>
                <Button
                  onClick={() =>
                    buttonChange(
                      incrementing ? "add" : "subtract",
                      "teleop_processor_scored"
                    )
                  }
                  variant="contained"
                  color={incrementing ? "secondary" : "red"}
                  sx={{
                    width: "100%",
                    minHeight: 100,
                  }}
                >
                  {`Scored Algae in Processor (${
                    formData?.teleop_processor_scored ?? 0
                  })`}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      )}
      {/*Endgame*/}
      {visualTime === 16 && (
        <Box>
          <Grid container sx={{ my: 1 }}>
            {/*Title*/}
            <Grid item xs={12} sx={{ justifyItems: "center" }}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 2,
                  padding: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "60%",
                  bgcolor: "background.default",
                  mb: 2,
                }}
              >
                <Typography
                  variant="h5"
                  color="secondary.light"
                  sx={{ textAlign: "center" }}
                >
                  <b>E N D G A M E</b>
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={0} sm={3} sx={{ justifyItems: "center" }}></Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ justifyItems: "center", px: 2, mb: 3 }}
            >
              <Select
                name="endgame_type"
                label="Climb"
                defaultValue={"no_attempt"}
                onChange={handleStringChange}
                sx={{
                  width: "100%",
                }}
              >
                <MenuItem value={"no_attempt"}>Didn't Attempt</MenuItem>
                <MenuItem value={"parked"}>Parked</MenuItem>
                <MenuItem value={"failed_shallow"}>
                  Failed Shallow Cage
                </MenuItem>
                <MenuItem value={"failed_deep"}>Failed Deep Cage</MenuItem>
                <MenuItem value={"succeeded_shallow"}>
                  Succeeded Shallow
                </MenuItem>
                <MenuItem value={"succeeded_deep"}>Succeeded Deep</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={0} sm={3} sx={{ justifyItems: "center" }}></Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{ justifyItems: "left", px: 1, py: 1 }}
            >
              <Typography
                variant="h7"
                color="secondary.light"
                letterSpacing={1}
              >
                <b>TRAITS</b>
              </Typography>
              <FormGroup
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography color="white" sx={{ minWidth: "120px" }}>
                    Speed
                  </Typography>
                  <Slider
                    name="robot_speed"
                    size="large"
                    aria-label="Speed"
                    defaultValue={3}
                    step={1}
                    marks
                    min={1}
                    max={5}
                    sx={{
                      flexGrow: 1,
                      "& .MuiSlider-track": { height: 6 },
                    }}
                    onChange={handleSliderChange}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography color="white" sx={{ minWidth: "120px" }}>
                    Agility
                  </Typography>
                  <Slider
                    name="robot_agility"
                    size="large"
                    aria-label="Agility"
                    defaultValue={3}
                    step={1}
                    marks
                    min={1}
                    max={5}
                    sx={{
                      flexGrow: 1,
                      "& .MuiSlider-track": { height: 6 },
                    }}
                    onChange={handleSliderChange}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography color="white" sx={{ minWidth: "120px" }}>
                    Defense
                  </Typography>
                  <Slider
                    name="robot_defense"
                    size="large"
                    aria-label="Defense"
                    defaultValue={0}
                    step={1}
                    marks
                    min={0}
                    max={5}
                    sx={{
                      flexGrow: 1,
                      "& .MuiSlider-track": { height: 6 },
                    }}
                    onChange={handleSliderChange}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <Typography color="white" sx={{ minWidth: "120px" }}>
                    Climbing Speed
                  </Typography>
                  <Slider
                    name="robot_climbing_speed"
                    size="large"
                    aria-label="Climbing Speed"
                    defaultValue={0}
                    step={1}
                    marks
                    min={0}
                    max={5}
                    sx={{
                      flexGrow: 1,
                      "& .MuiSlider-track": { height: 6 },
                    }}
                    onChange={handleSliderChange}
                  />
                </Box>
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2}
              sx={{ justifyItems: "left", px: 1, py: 1 }}
            >
              <Typography
                variant="h7"
                color="secondary.light"
                letterSpacing={1}
              >
                <b>ABILITY</b>
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_coral_can_handle"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Can Hold Coral"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_algae_controlled"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Can Hold Algae"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_dislodge_algae"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Can Dislodge Algae"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_travel_under_barge"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Can Go To Other Side"
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2}
              sx={{ justifyItems: "left", px: 1, py: 1 }}
            >
              <Typography
                variant="h7"
                color="secondary.light"
                letterSpacing={1}
              >
                <b>UNFORTUNATE</b>
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_mistakes_lost_comms"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Lost Comms"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_mistakes_stuck_piece"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Game Piece Stuck"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_mistakes_extra_piece"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Held 2 GP at Once"
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2}
              sx={{ justifyItems: "left", px: 1, py: 1 }}
            >
              <Typography
                variant="h7"
                color="secondary.light"
                letterSpacing={1}
              >
                <b>ROBOT</b>
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_tippy"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Almost Tipped"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_tipped"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Tipped"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="robot_damaged"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Is Damaged"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_gameplay_battlebot"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Damaged Others"
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={3}
              sx={{ justifyItems: "left", px: 1, py: 1 }}
            >
              <Typography
                variant="h7"
                color="secondary.light"
                letterSpacing={1}
              >
                <b>GAMEPLAY</b>
              </Typography>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_official_foul"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Foul"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_gameplay_nuisance"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Got In Way"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_gameplay_touched_cage"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Touched Opponents Cage"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="errors_gameplay_knocked_cage"
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Knocked Teammate Off Cage"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={0} md={4} lg={0}></Grid>
            <Grid item xs={12} sx={{ justifyItems: "center", px: 2, py: 1 }}>
              <TextField
                name="notes"
                variant="filled"
                label="Notes"
                multiline
                onBlur={handleStringChange}
                sx={{
                  width: "100%",
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ justifyItems: "center", px: 2 }}>
              <Button
                variant="contained"
                sx={{
                  width: "100%",
                }}
                onClick={() => (submitEnabled ? handleCreateMatch() : "")}
              >
                S U B M I T
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Div>
  );
}
